import { render } from "./ProjectFall.vue?vue&type=template&id=7de44ed8"
import script from "./ProjectFall.vue?vue&type=script&lang=js"
export * from "./ProjectFall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__